import { render, staticRenderFns } from "./News.vue?vue&type=template&id=5f1e96c1&scoped=true"
import script from "./News.vue.js?vue&type=script&lang=js&external"
export * from "./News.vue.js?vue&type=script&lang=js&external"
import style0 from "./News.vue?vue&type=style&index=0&id=5f1e96c1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1e96c1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
